<script>
export default {
  name: 'LeftNav',
  data() {
    return {
      expanded: false,
      hoveredKey: null,
      // label 은 i18n 키로 — template 에서 $t(menu.labelKey) 로 lookup
      menus: [
        { key: 'monitoring',  labelKey: 'nav.monitoring',  route: '/' },
        { key: 'leak',        labelKey: 'nav.leak',        route: '/water-leak' },
        { key: 'logger',      labelKey: 'nav.logger',      route: '/logger' },
        { key: 'gis-master',  labelKey: 'nav.gis_master',  route: '/gis-master' },
        { key: 'maintenance', labelKey: 'nav.maintenance', route: '/maintenance' },
      ],
    }
  },
  methods: {
    toggle() {
      this.expanded = !this.expanded
    },
    navigate(route) {
      this.$router.push(route)
      this.expanded = false
    },
    isActive(route) {
      return this.$route.path === route
    },
    tooltipText(menu) {
      if (menu?.key === 'monitoring') {
        // 모니터링 메뉴만 이름 대신 설명형 툴팁 사용
        return '실시간 계측 데이터와 지점 상태를 모니터링합니다'
      }
      return this.$t(menu.labelKey)
    },
  },
}
</script>

<template>
  <nav class="left-nav" :class="{ expanded }">

    <!-- 토글 버튼 -->
    <button class="toggle-btn" @click="toggle" :title="expanded ? $t('nav.collapse') : $t('nav.expand')">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <line x1="3" y1="6"  x2="21" y2="6"/>
        <line x1="3" y1="12" x2="21" y2="12"/>
        <line x1="3" y1="18" x2="21" y2="18"/>
      </svg>
    </button>

    <!-- 메뉴 아이템 -->
    <div class="menu-list">
      <div
        v-for="menu in menus"
        :key="menu.key"
        class="menu-item"
        :class="{ active: isActive(menu.route) }"
        @click="navigate(menu.route)"
        @mouseenter="hoveredKey = menu.key"
        @mouseleave="hoveredKey = null"
      >
        <!-- 아이콘 -->
        <span class="menu-icon">
          <!-- Monitoring -->
          <svg v-if="menu.key === 'monitoring'" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round">
            <rect x="3" y="3" width="18" height="18" rx="2"/>
            <path d="M3 9h18M9 21V9"/>
          </svg>
          <!-- Water Leak Detection -->
          <svg v-else-if="menu.key === 'leak'" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round">
            <path d="M12 2C6 8 4 12 4 15a8 8 0 0016 0c0-3-2-7-8-13z"/>
            <path d="M12 22v-4M8 18l2-2M16 18l-2-2"/>
          </svg>
          <!-- Logger -->
          <svg v-else-if="menu.key === 'logger'" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round">
            <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/>
            <polyline points="14 2 14 8 20 8"/>
            <line x1="8" y1="13" x2="16" y2="13"/>
            <line x1="8" y1="17" x2="16" y2="17"/>
          </svg>
          <!-- GIS Master -->
          <svg v-else-if="menu.key === 'gis-master'" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round">
            <polygon points="1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6"/>
            <line x1="8" y1="2" x2="8" y2="18"/>
            <line x1="16" y1="6" x2="16" y2="22"/>
          </svg>
          <!-- Maintenance -->
          <svg v-else-if="menu.key === 'maintenance'" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round">
            <path d="M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z"/>
          </svg>
        </span>

        <!-- 라벨 (expanded 상태에서만) -->
        <span v-if="expanded" class="menu-label">{{ $t(menu.labelKey) }}</span>

        <!-- 툴팁 (collapsed + hover 시) -->
        <div
          v-if="!expanded && hoveredKey === menu.key"
          class="menu-tooltip"
        >
          {{ tooltipText(menu) }}
        </div>
      </div>
    </div>
  </nav>
</template>

<style scoped>
.left-nav {
  width: 56px;
  height: 100%;
  background-color: var(--bg-base);
  border-right: 1px solid var(--border-subtle);
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  transition: width 0.22s ease;
  overflow: visible;
  z-index: 100;
}

.left-nav.expanded {
  width: 210px;
}

/* 토글 버튼 */
.toggle-btn {
  width: 100%;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  border-bottom: 1px solid var(--border-subtle);
  color: var(--text-disabled);
  cursor: pointer;
  flex-shrink: 0;
  transition: color .2s, background .2s;
}
.toggle-btn:hover {
  color: var(--accent);
  background: rgba(var(--accent-rgb),.06);
}

/* 메뉴 리스트 */
.menu-list {
  display: flex;
  flex-direction: column;
  padding: 0.5rem 0;
  gap: 2px;
}

/* 메뉴 아이템 */
.menu-item {
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0 0 0 0;
  height: 48px;
  cursor: pointer;
  color: var(--text-disabled);
  border-left: 2px solid transparent;
  transition: color .2s, background .2s, border-color .2s;
  white-space: nowrap;
  overflow: visible;
}
.menu-item:hover {
  color: var(--text-muted);
  background: var(--left-nav-hover-bg);
}
.menu-item.active {
  color: var(--accent);
  background: var(--left-nav-active-bg);
  border-left-color: var(--accent);
}

.menu-icon {
  width: 56px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.menu-label {
  font-size: 0.8125rem;
  font-weight: 500;
  letter-spacing: .02em;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 툴팁 */
.menu-tooltip {
  position: absolute;
  left: calc(100% + 8px);
  top: 50%;
  transform: translateY(-50%);
  background: rgba(10,18,32,.96);
  border: 1px solid var(--border-subtle);
  border-radius: 0.375rem;
  padding: 5px 10px;
  font-size: 0.8125rem;
  color: var(--text-primary);
  white-space: nowrap;
  pointer-events: none;
  z-index: 9999;
  box-shadow: 0 4px 12px rgba(0,0,0,.4);
}
.menu-tooltip::before {
  content: '';
  position: absolute;
  right: 100%;
  top: 50%;
  transform: translateY(-50%);
  border: 5px solid transparent;
  border-right-color: var(--border-subtle);
}

/* 라이트 테마 — 좌측 메뉴바를 진한 네이비 솔리드로 (헤더바와 동일 프레임). 활성은 sky 포인트 */
:root[data-theme="light"] .left-nav {
  background: var(--bar-bg);
  border-right-color: rgba(255,255,255,.10);
}
:root[data-theme="light"] .toggle-btn {
  color: var(--bar-fg-muted);
  border-bottom-color: var(--bar-border);
}
:root[data-theme="light"] .toggle-btn:hover {
  color: #fff;
  background: var(--bar-hover-bg);
}
:root[data-theme="light"] .menu-item {
  color: var(--bar-fg-muted);
  border-left-color: transparent;
}
:root[data-theme="light"] .menu-item:hover {
  color: var(--bar-fg);
  background: var(--bar-hover-bg);
}
/* 활성 메뉴 — 아이콘 주위에 둥근 시안 박스 (이미지 스타일). 행 배경/좌측라인은 제거 */
:root[data-theme="light"] .menu-item.active {
  color: var(--bar-point);
  background: transparent;
  border-left-color: transparent;
}
:root[data-theme="light"] .menu-item.active .menu-icon {
  position: relative;
}
:root[data-theme="light"] .menu-item.active .menu-icon::before {
  content: '';
  position: absolute;
  inset: 5px 9px;
  border-radius: 10px;
  background: var(--bar-active-bg);
  border: 1px solid rgba(34,211,238,.55);
  z-index: 0;
}
:root[data-theme="light"] .menu-item.active .menu-icon svg {
  position: relative;
  z-index: 1;
}
/* 툴팁 — 라이트 테마에선 글자색(--text-primary)이 진해 어두운 배경과 안 맞음.
   메뉴바와 동일한 네이비 배경 + 밝은 글자로 조정 */
:root[data-theme="light"] .menu-tooltip {
  background: var(--bar-bg);
  color: var(--bar-fg);
  border-color: var(--bar-border);
  box-shadow: 0 4px 12px rgba(15,23,42,.2);
}
:root[data-theme="light"] .menu-tooltip::before {
  border-right-color: var(--bar-border);
}
</style>
